export default {
      id: "graph-estrie-usage",
      viewBox: "0 0 122 164",
      url: __webpack_public_path__ + "svg/sprite.svg#graph-estrie",
      toString: function () {
        return this.url;
      }
    }